
import { Polygon } from "@react-google-maps/api";
import { regionColors } from "./regionData";

interface RegionPolygonProps {
  region: string;
  coordinates: google.maps.LatLngLiteral[];
  onClick: (region: string) => void;
}

const RegionPolygon = ({ region, coordinates, onClick }: RegionPolygonProps) => {
  return (
    <Polygon
      key={region}
      paths={coordinates}
      options={{
        fillColor: regionColors[region as keyof typeof regionColors].fill,
        fillOpacity: 0.7,
        strokeColor: regionColors[region as keyof typeof regionColors].stroke,
        strokeOpacity: 1,
        strokeWeight: 2
      }}
      onClick={() => onClick(region)}
    />
  );
};

export default RegionPolygon;
